import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "shared/const/localstorage";
import axios from "axios";
import {LessonsDemoResponse} from "../../../types/lessons/lessons-demo/lessonsDemoSchema";
import {setLessonsDemo, setResponseSubscribedLessonId} from "../../../slice/lessons/lessons-demo/setLessonsDemo";
import {createRequestParams} from "common/hook/create-request-params/createRequestParams";


interface FetchLessonsParams {
    from?: string;
    to?: string;
    page?: number;
}


export const fetchLessonsDemo = createAsyncThunk(
    "lessons-demo",
    async ({from, to, page}: FetchLessonsParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const params = createRequestParams(from, to, page);

            const response = await axios.get<LessonsDemoResponse>(
                `/api/lessons`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params,
                }
            );

            if (response.data && response.data.success) {
                thunkAPI.dispatch(setLessonsDemo(response.data.data))
                thunkAPI.dispatch(setResponseSubscribedLessonId(response.data.data.subscribedLessonId))
            }
            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);